import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import {
    Checkbox, Collapse,
    FormControlLabel,
    FormGroup,
    IconButton,
} from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import * as React from "react";
import useCheckMobileScreen from '../../utils/detect-mobile-size';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticTimePicker } from '@mui/x-date-pickers';
import { useEffect } from 'react';

export default function OrderTimeModal(props: { onClose: any; open: any; }) {
    const { onClose, open } = props;
    const [selectedTime, setSelectedTime] = React.useState<Date | null>(null);
    const [asap, setAsap] = React.useState(true);

    let isMobile = useCheckMobileScreen();

    const handleClose = (time: Date) => {
        if (!asap) {
            setSelectedTime(time)
            onClose(time)
        }
    };

    const handleChangeBox = (event: { target: { checked: boolean; }; }) => {
        setAsap(event.target.checked);
    }

    const acceptAsap = () => {
        onClose(null);
    }

    useEffect(() => {
        if (selectedTime) {
            setAsap(false);
        }
    }, [asap, selectedTime])

    return (
        <Dialog PaperProps={{ style: { borderRadius: !isMobile ? "1.5rem" : "" } }} fullScreen={isMobile} onClose={handleClose} open={open} fullWidth={true}>
            <DialogTitle>Bezorgtijd
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>

            <div className="w-full px-8 pb-8 select-none">
                <FormGroup>
                    {/*TODO make disabled when not able to order yet due to time*/}
                    <div className="flex">
                        <FormControlLabel className="w-full " disabled={false} control={<Checkbox onChange={(e) => handleChangeBox(e)} defaultChecked />} label="Zo snel mogelijk" />
                        { asap &&
                            <button onClick={() => acceptAsap()} className="action-button w-28 py-1 rounded-full font-bold text-xl">Ok</button>
                        }
                    </div>
                </FormGroup>

                <Collapse in={!asap}>
                    <div className="separator">Of kies een tijdstip</div>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <StaticTimePicker
                            autoFocus={true}
                            disablePast={true}

                            ampm={false}
                            orientation={isMobile ? "portrait" : "landscape"}
                            minutesStep={5}
                            localeText={{toolbarTitle: 'Kies tijdstip', cancelButtonLabel: 'opnieuw', okButtonLabel: 'kies tijdstip'}}
                            disabled={asap}
                            onAccept={(time: any) => {
                                handleClose(time)
                            }}
                        />
                    </LocalizationProvider>
                </Collapse>
            </div>
        </Dialog>
    );
}
OrderTimeModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};